var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{staticClass:"select-input",attrs:{"options":this.options,"value":this.value},on:{"change":function($event){return _vm.$emit('change', $event, _vm.type, false)},"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }